import React from 'react';

import InventoryDashboard from '@sophocles/views/inventory/components/InventoryDashboard';

function CustomerInventoryView(props) {
  return <InventoryDashboard {...props} />;
}

export default CustomerInventoryView;
